module.exports = __webpack_public_path__ + "img/asia-admin03.904a7ad8.png";